import { render, staticRenderFns } from "./shopAdsList.vue?vue&type=template&id=4e8825e3"
import script from "./shopAdsList.vue?vue&type=script&lang=js"
export * from "./shopAdsList.vue?vue&type=script&lang=js"
import style0 from "./shopAdsList.vue?vue&type=style&index=0&id=4e8825e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports